import {useCallback, useState } from "react";
import settingsService from "../../services/settings/settingsService";

export interface ISongsPageLogic {
  openModal: () => void;
  closeModal: () => void;
  isModalVisible: boolean,
}

export const useSongsPageLogic = (): ISongsPageLogic => {
  const [isModalVisible, setModalState] = useState<boolean>(!settingsService.hasSongModalBeenDisplayed());

  const openModal = useCallback(() => {
    setModalState(true)
  }, [setModalState]);

  const closeModal = useCallback(() => {
    setModalState(false)
  }, [setModalState]);

  return {
    openModal,
    closeModal,
    isModalVisible,
  };
}
